<!--<header>-->
<!--  <div class="container-small">-->
<!--    <div class="header">-->
<!--      <div class="header__logo">-->
<!--        <a href="/">-->
<!--          <img src="assets/images/removia-logo-white.svg" alt="logo">-->
<!--        </a>-->
<!--      </div>-->
<!--      <div class="header__btn">-->
<!--        <a href="#plan" id="scroll-down-mobile" class="mobile button default">-->
<!--          Plan-->
<!--        </a>-->
<!--        <a href="/dashboard" target="_blank" class="button grad">-->
<!--          Log in-->
<!--        </a>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</header>-->

<!--<main>-->
<!--  <section class="plan" id="plan" style="margin-top: 100px;">-->
<!--    <div class="container-extra-small">-->
<!--      <div class="plan__wrapper">-->
<!--        <div class="plan__list">-->
<!--          <div class="plan__list__switcher">-->
<!--            <div class="plan__list__switcher&#45;&#45;inner">-->
<!--              <span class="plan__list__switcher&#45;&#45;premium switcher-item active" data-plan="premium">Premium</span>-->
<!--              <span class="plan__list__switcher&#45;&#45;standard switcher-item" data-plan="standard">Standard</span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="plan__list__section premium active">-->
<!--            <div class="plan__list__item best">-->
<!--              <div class="plan__list__item&#45;&#45;inner">-->
<!--                <div class="plan__list__item&#45;&#45;best">BEST VALUE</div>-->
<!--                <div class="plan__list__item&#45;&#45;title">Ultimate</div>-->
<!--                <div class="plan__list__item&#45;&#45;price-month">-->
<!--                  <span class="currency">$</span>-->
<!--                  <span class="amount">399</span>-->
<!--                  <span class="decimal">.00</span>-->
<!--&lt;!&ndash;                  <span class="period">/annualy</span>&ndash;&gt;-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;price-all">-->
<!--                  <span>$496</span>-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;text">billed annualy</div>-->
<!--                <div class="plan__list__item&#45;&#45;list">-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    300 data brokers covered-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    5 emails monitored-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Up to 4 people secured-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Re-checks every 90 days-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Personal privacy dashboard-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;check">-->
<!--                  <input type="radio" id="ultimate" name="radio-premium" data-price="496" data-sale="399"-->
<!--                         data-attr="removia-ultimate-12-months" checked>-->
<!--                  <label for="ultimate" class="radio-label"></label>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="plan__list__item">-->
<!--              <div class="plan__list__item&#45;&#45;inner">-->
<!--                <div class="plan__list__item&#45;&#45;title">Advanced</div>-->
<!--                <div class="plan__list__item&#45;&#45;price-month">-->
<!--                  <span class="currency">$</span>-->
<!--                  <span class="amount">299</span>-->
<!--                  <span class="decimal">.00</span>-->
<!--&lt;!&ndash;                  <span class="period">/annualy</span>&ndash;&gt;-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;price-all">-->
<!--                  <span>$388</span>-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;text">billed annualy</div>-->
<!--                <div class="plan__list__item&#45;&#45;list">-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    200 data brokers covered-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    3 emails monitored-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Up to 2 people secured-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Re-checks every 90 days-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Personal privacy dashboard-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;check">-->
<!--                  <input type="radio" id="plus" name="radio-premium" data-price="388" data-sale="299"-->
<!--                         data-attr="removia-advanced-12-months">-->
<!--                  <label for="plus" class="radio-label"></label>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="plan__list__section standard">-->
<!--            <div class="plan__list__item">-->
<!--              <div class="plan__list__item&#45;&#45;inner">-->
<!--                <div class="plan__list__item&#45;&#45;title">Pro</div>-->
<!--                <div class="plan__list__item&#45;&#45;price-month">-->
<!--                  <span class="currency">$</span>-->
<!--                  <span class="amount">249</span>-->
<!--                  <span class="decimal">.00</span>-->
<!--&lt;!&ndash;                  <span class="period">/annualy</span>&ndash;&gt;-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;price-all">-->
<!--                  <span>$348</span>-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;text">billed annualy</div>-->
<!--                <div class="plan__list__item&#45;&#45;list">-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    150 data brokers covered-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    2 emails monitored-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Up to 1 people secured-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Re-checks every 90 days-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Personal privacy dashboard-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;check">-->
<!--                  <input type="radio" id="basic" name="radio-standard" data-price="348" data-sale="249"-->
<!--                         data-attr="removia-pro-12-months" checked>-->
<!--                  <label for="basic" class="radio-label"></label>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="plan__list__item">-->
<!--              <div class="plan__list__item&#45;&#45;inner">-->
<!--                <div class="plan__list__item&#45;&#45;title">Lite</div>-->
<!--                <div class="plan__list__item&#45;&#45;price-month">-->
<!--                  <span class="currency">$</span>-->
<!--                  <span class="amount">199</span>-->
<!--                  <span class="decimal">.00</span>-->
<!--&lt;!&ndash;                  <span class="period">/annualy</span>&ndash;&gt;-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;price-all">-->
<!--                  <span>$268</span>-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;text">billed annualy</div>-->
<!--                <div class="plan__list__item&#45;&#45;list">-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    100 data brokers covered-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    1 emails monitored-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    1 person secured-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Re-checks every 90 days-->
<!--                  </div>-->
<!--                  <div class="plan__list__item&#45;&#45;list&#45;&#45;item">-->
<!--                    <i class="icon ion-android-done"></i>-->
<!--                    Personal privacy dashboard-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="plan__list__item&#45;&#45;check">-->
<!--                  <input type="radio" id="lite" name="radio-standard" data-price="268"-->
<!--                         data-attr="removia-lite-12-months" data-sale="199">-->
<!--                  <label for="lite" class="radio-label"></label>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="plan__info">-->
<!--          <div class="plan__info&#45;&#45;inner" style="padding-bottom: 25px">-->
<!--            <div class="plan__info&#45;&#45;title">-->
<!--              <span>Find the Right</span> <br> Plan for You-->
<!--            </div>-->
<!--            <div class="plan__info&#45;&#45;logo">-->
<!--              <img src="assets/images/logo.svg" alt="plan-logo">-->
<!--            </div>-->
<!--            <div class="plan__info&#45;&#45;pay">-->
<!--              <div class="plan__info&#45;&#45;pay&#45;&#45;text">You pay today:</div>-->
<!--              <div class="plan__info&#45;&#45;pay&#45;&#45;sale">$<span class="price">496</span></div>-->
<!--              <div class="plan__info&#45;&#45;pay&#45;&#45;price">$<span class="sale">399</span></div>-->
<!--            </div>-->
<!--            <a href="#" class="buy button white not-scroll" data-cell="standard" data-fsc-action="Add,Checkout"-->
<!--               data-fsc-item-path-value="removia-ultimate-12-months" target="_blank" role="button"-->
<!--               rel="noreferrer noopener" aria-label="callback button">-->
<!--              Buy Now-->
<!--            </a>-->
<!--            <div class="plan__info&#45;&#45;bottom">-->
<!--              By clicking Buy Now you automatically agree to the Terms of Use and <a href="#">Privacy Policy</a> of Removia-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->
<!--</main>-->

<!--&lt;!&ndash; Футер &ndash;&gt;-->
<!--<footer>-->
<!--  <div class="container">-->
<!--    <div class="footer__wrapper">-->
<!--      <div class="footer__img">-->
<!--        <img src="assets/images/banner.svg" alt="banner">-->
<!--      </div>-->
<!--      <div class="footer__links">-->
<!--        <div class="footer__links__item">-->
<!--          <div class="footer__links__title">-->
<!--            Menu-->
<!--          </div>-->
<!--          <div class="footer__links__list">-->
<!--            <a href="/" target="_blank">Home</a>-->
<!--            <a href="/blog" target="_blank">Blog</a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="footer__links__item">-->
<!--          <div class="footer__links__title">-->
<!--            Resources-->
<!--          </div>-->
<!--          <div class="footer__links__list">-->
<!--            <a href="#" target="_blank">Privacy Policy</a>-->
<!--            <a href="#" target="_blank">Terms of use</a>-->
<!--            <a href="#" target="_blank">Refund Policy</a>-->
<!--            <a href="#" target="_blank">EULA</a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="footer__links__item">-->
<!--          <div class="footer__links__list" style="padding-top: 48px">-->
<!--            <a href="#" target="_blank">Cookie Policy</a>-->
<!--            <a href="#" target="_blank">GDPR Notice</a>-->
<!--            <a href="#" target="_blank">CCPA Notice</a>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="footer__logo">-->
<!--        <img style="padding-bottom: 15px" src="assets/images/removia-logo-white.svg" alt="logo">-->
<!--        <br>-->
<!--        <div>-->
<!--          <div>-->
<!--            <span style="color: white; font-family: Manrope; font-weight: 800; font-size: 18px; line-height: 32px; letter-spacing: 0px; text-transform: uppercase;">-->
<!--              Contact us-->
<!--            </span>-->
<!--            <br>-->
<!--            <span style="color: white; font-family: Manrope; font-weight: 300; font-size: 18px; line-height: 22px; letter-spacing: -0.5px; text-decoration: underline; text-decoration-style: solid; text-decoration-offset: 0%; text-decoration-thickness: 0%; ">-->
<!--              support@removia.io-->
<!--            </span>-->
<!--          </div>-->
<!--          <div>-->
<!--            <p  style="margin-top: 10px; padding-top: 10px; color:#FFFFFF; font-family: Manrope; font-weight: 300; font-size: 18px; line-height: 26px; letter-spacing: 0px;">-->
<!--              GotYourBack Technologies LTD-->
<!--              <br>-->
<!--              Ifigeneias 14, 3036 Limassol, Cyprus-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</footer>-->

<app-landing-header></app-landing-header>
<app-landing-pricing></app-landing-pricing>
<app-landing-footer></app-landing-footer>
